import { useState } from 'react';
import { callApi } from '../api/callApi';
import { API_ENDPOINT, API_URL } from '../api/constant';

interface DeleteFileResult {
    deleteFile: (filePath: string) => Promise<void>;
    isDeleting: boolean;
    error: string | null;
}

const useFileDelete = (): DeleteFileResult => {
    const [isDeleting, setIsDeleting] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const deleteFile = async (filePath: string): Promise<void> => {
        setIsDeleting(true);
        setError(null);

        try {
            await callApi(
                `${API_URL}${API_ENDPOINT.page}file-upload/delete-file`,
                {
                    data: { path: filePath },
                    method: 'POST'
                }
            );
        } catch (err: any) {
            setError(err.message || 'Unable to delete file. Please try again.');
            throw new Error(err.message || 'Delete operation failed');
        } finally {
            setIsDeleting(false);
        }
    };

    return { deleteFile, isDeleting, error };
};

export default useFileDelete;